import { useState, useEffect, useCallback } from 'react'
import { useWeb3React } from './useWeb3React'
import { formatUnits} from 'viem'
import { MainTokenConfig } from '@/config'

const useBalance = () => {
  const [balance, setBalance] = useState(0)
  const { account, chainId, provider } = useWeb3React()
  useEffect(() => {
    if (chainId && provider && account) {
      getBalance()
    }
  }, [chainId, provider])
  const getBalance = useCallback(async () => {
    const balance_ = await provider.getBalance({
      address: account as `0x${string}` // account 已经是 0x 开头的字符串
    })
    // 可能有精度bug
    const _balance = formatUnits(balance_, MainTokenConfig[chainId][0].decimals)
    setBalance(Number(_balance))
  }, [chainId, provider, account])
  return balance
}

export default useBalance
